export default __webpack_public_path__ + "static/ai-gen-footer-light-fd6f5f33c182ac4d2974face0efdc6c134193e01ef966bc63da3af3bc10ccc98.png";